import { useMemo, useSyncExternalStore } from 'react'
import { browserTokenStorage } from '../../../platform/auth/browser-token-storage'
import { verifiedProfile } from '../application/verified-profile'

export type VerifiedAccount = Readonly<{
  key: string
  userId: number
  isCurrent: () => boolean
}>

/** Memory-only proof: cached profile data alone never authorizes a form action. */
export function useVerifiedAccount(): VerifiedAccount | null {
  const profile = useSyncExternalStore(
    verifiedProfile.subscribe,
    verifiedProfile.read,
    () => null,
  )
  const token = useSyncExternalStore(
    browserTokenStorage.subscribe,
    browserTokenStorage.read,
    () => null,
  )
  return useMemo(() => {
    if (!profile || !token || !verifiedProfile.matches(token)) return null
    return {
      key: `${String(profile.userId)}:${String(profile.generation)}`,
      userId: profile.userId,
      isCurrent: () =>
        verifiedProfile.read() === profile &&
        browserTokenStorage.read() === token &&
        verifiedProfile.matches(token),
    }
  }, [profile, token])
}
